import { injectable } from "inversify";
import { Bad, Ok } from "@leavy/result";

@injectable()
export abstract class SessionService {
    abstract extends(): Promise<Ok | Bad<"session_failed" | "user_not_allowed" | "session_expired" | "unexpected_authentication_failure">>;

    abstract end(): Promise<void>;
}
